import styled from 'styled-components';
import { ChecklistItemName } from '../ChecklistFilter/styled.js';

export const ContentFilterWrapper = styled.div`
  margin-bottom: 12px;
  padding: 36px;
  border-radius: 4px;
  box-shadow: 0 5px 9px 0 rgba(0,0,0,0.02);
  background: #ffffff;
  border-bottom: 1px solid #EDEDED;
`;

export const ContentFilterItemContainer = styled.div`
  padding-top: 12px;
  display: block;

  ${ChecklistItemName} {
    text-transform: capitalize;
  }
`;
